import type { ComponentType, CSSProperties, ReactNode } from "react";
import InfoHollowIconUntyped from "views/components/icons/InfoHollowIcon";
import style from "./style.module.css";

interface MessageIconProps {
  className?: string;
  color?: string;
  height?: string;
  noPointer?: boolean;
  size?: string;
  style?: CSSProperties;
  title?: string;
  viewBox?: string;
  width?: string;
}

const InfoHollowIcon = InfoHollowIconUntyped as ComponentType<MessageIconProps>;

interface MessageProps {
  children?: ReactNode;
  icon?: ComponentType<MessageIconProps>;
}

const Message = ({ children, icon: Icon = InfoHollowIcon }: MessageProps) => (
  <div className={style.messageContainer}>
    <Icon
      color="var(--color-easil-blue)"
      size="20px"
      className={style.messageIcon}
    />
    <div className={style.messageContent}>{children}</div>
  </div>
);

export default Message;
